import { FetchArgs } from '@reduxjs/toolkit/query'
import { assign, isString } from 'lodash-es'
import {
  BOGUS_TOKEN_SERVICE_ERROR_CODE,
  bogusTokenService,
} from '@/api/utils/bogus-token-service'
import { HeaderName } from '@/constants/header-name'
import { isClient } from '@/utils/is-client'
import { BaseQuery } from '@/utils/redux-toolkit'

export const bogusTokenInjector: (baseQuery: BaseQuery) => BaseQuery =
  (baseQuery: BaseQuery) => async (args, api, extraOptions) => {
    if (isString(args)) {
      const bogusToken = await bogusTokenService.generate(args)

      const fetchArgs: FetchArgs = {
        url: args,
        headers: {
          [HeaderName.IkalaBogusToken]: bogusToken,
        },
      }

      const result = await baseQuery(fetchArgs, api, extraOptions)

      if (
        result.meta?.response?.status === BOGUS_TOKEN_SERVICE_ERROR_CODE &&
        isClient()
      ) {
        bogusTokenService.invalidateVersion()
      }

      return result
    }

    const bogusToken = await bogusTokenService.generate(
      args.url,
      args.params,
      args.body,
    )

    args.headers = assign({}, args.headers, {
      [HeaderName.IkalaBogusToken]: bogusToken,
    })

    const response = await baseQuery(args, api, extraOptions)

    if (
      response.meta?.response?.status === BOGUS_TOKEN_SERVICE_ERROR_CODE &&
      isClient()
    ) {
      bogusTokenService.invalidateVersion()
    }

    return response
  }

export default bogusTokenInjector
